module.exports = __webpack_public_path__ + "static/img/wxapp.7aa374d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wxapp.png
// module id = /ZUM
// module chunks = 0